import { PAGE_HOME_INCLUSIONE, PAGE_HOME_URL, PAGE_INCLUSIONE_RICONGIUNGIMENTO } from 'types/url';

export const breadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Ricongiungimento familiare',
    url: PAGE_INCLUSIONE_RICONGIUNGIMENTO,
  },
  {
    slash: 'VOGLIO RICONGIUNGERMI CON UN PARENTE',
    url: '',
  },
];

export const title = 'WeMi - Inclusione - Ricongiungimento familiare - Voglio ricongiungermi con un parente';
export const description = 'Descrizione servizio ricongiungimento con un parente';
export const keywords = 'welfare, milano, servizi, servizio, Ricongiungimento con un parente, servizio ricongiungimento con un parente, informazioni servizio ricongiungimento con un parente';
